import shouldBehaveAsMobile from '@hypatia/utils/os/shouldBehaveAsMobile'
import useScreenDim from '@hypatia/react-hooks/useScreenDim'
import useScreenOrientation from '@hypatia/react-hooks/useScreenOrientation'
import useTheme from '@material-ui/core/styles/useTheme'
import noop from 'lodash/noop'
import React, { useEffect } from 'react'
import { createContext, useContext } from 'use-context-selector'

export type ScreenSize = 'sm' | 'lg'

export type ScreenSizeContextType = ScreenSize

export const ScreenSizeContext = createContext<ScreenSizeContextType>('lg')

export const useScreenSize = () => useContext(ScreenSizeContext)

interface Props {
    children: React.ReactChild
}

export default function ScreenSize({ children }: Props) {
    const theme = useTheme()
    const { height, width } = useScreenDim()
    const isSm = Math.min(height, width) < theme.breakpoints.values.sm
    const orientation = useScreenOrientation()

    useEffect(() => {
        try {
            window.screen?.orientation?.lock?.('portrait')?.catch(noop)
        } catch {
            /*  */
        }
    }, [])

    const value = shouldBehaveAsMobile(orientation) || isSm ? 'sm' : 'lg'
    return <ScreenSizeContext.Provider value={value}>{children}</ScreenSizeContext.Provider>
}
